<template src="./template/index.html"></template>
<script>
import DibbleJS from "../../../dibble";
import DibbleApi from "../../../api";
import NoRentalDayModal from "../NoRentalDayModal/NoRentalDayModal.vue";
export default {
    name: 'NoRentalDays',
    display: "Transition",
    data () {
        return {
            dibbleJs: DibbleJS,
            offDays: [],
            isShowNoRentalModal: false,
            currentStatusInspectItem: '',
            currentDateEdit: this.$moment(new Date()),
            currentReason: ''
        }
    },
    mounted () {
        this.getListNoRentalDays()
    },
    methods: {
        _onSuccess(response) {
            this.dibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                this.offDays = []
                Object.keys(response.off_days).forEach(el => {
                    this.offDays.push({
                        date: el,
                        contentDate: response.off_days[el]
                    })
                })
            }
        },
        getListNoRentalDays() {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.getOffDaysList,
                token: DibbleJS.getStorageToken()
            };
            this.dibbleJs.callApiRequest(params, this._onSuccess);
        },
        openModalUpdateRental (type, day) {
            if (type.toLowerCase() === 'add') {
                this.currentDateEdit = this.$moment(new Date())
                this.currentReason = ''
            } else {
                this.currentDateEdit = this.$moment(day['date'], 'YYYY-MM-DD')
                this.currentReason = day['contentDate']
            }

            this.isShowNoRentalModal = true
            this.currentStatusInspectItem = type
        },
        closeModalUpateRental () {
            this.isShowNoRentalModal = false
        },
        getDateUpdateRentalModal (data) {
            this.isShowNoRentalModal = false
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.setOffDaysList,
                date: this.$moment(data.date, 'MM/DD/YYYY').format('YYYY-MM-DD'),
                reason: data.reason,
                token: DibbleJS.getStorageToken()
            };
            this.dibbleJs.callApiRequest(params, (response => {
                DibbleJS.hideLoader();
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJS.toastSuccessMessage(response.message)
                    this.getListNoRentalDays()
                } else {
                    DibbleJS.toastErrorMessage(response.message)
                }
            }));
        },
        deleteNoRentalDate(dateStr) {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.unsetOffDay,
                date: this.$moment(dateStr, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                token: DibbleJS.getStorageToken()
            };
            this.dibbleJs.callApiRequest(params, (response => {
                DibbleJS.hideLoader();
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJS.toastSuccessMessage(response.message)
                    this.getListNoRentalDays()
                } else {
                    DibbleJS.toastErrorMessage(response.message)
                }
            }));
        }
    },
    components: {
        NoRentalDayModal
    }
}
</script>
<style scoped>
    tr.order-row {
        cursor: pointer;
    }
    tr.order-row:hover {
        background-color: #e1e1e1;
    }
    .btn-4 {
        margin-top: 0px;
    }
    .table th, .table td {
        vertical-align: middle !important;
    }
</style>
